import { Card } from "@/components/ui/Card";

interface Props {
  title: string;
  value: string | number;
  subtitle?: string;
  variation?: number;
  icon: React.ReactNode;
  accentClass?: string;
  loading?: boolean;
  onClick?: () => void;
}

export function LocacoesStatCard({
  title,
  value,
  subtitle,
  variation,
  icon,
  accentClass = "border-l-4 border-l-slate-300",
  loading,
  onClick,
}: Props) {
  return (
    <Card
      title={title}
      value={value}
      subtitle={subtitle}
      variation={variation}
      icon={icon}
      className={accentClass}
      loading={loading}
      onClick={loading ? undefined : onClick}
    />
  );
}
